import { render, staticRenderFns } from "./churn.vue?vue&type=template&id=24718e52&"
import script from "./churn.vue?vue&type=script&lang=ts&"
export * from "./churn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports